<template>
    <div class="announcement">
        <div class="container-fluid">
            <header class="stdenis-header pd-t-30">
                <h2>Announcements <i class="icon ion-md-megaphone"></i> </h2>
                <p></p>
            </header>
            <div class="row">

                <div class="col-lg-4 col-md-12 announcement-container" v-for="announcement in announcementList" :key="announcement.title">
                    <div>
                        <b-card
                                :title="announcement.title"
                                img-src="https://i2.wp.com/www.vanguardngr.com/wp-content/uploads/2020/03/Catholic-Church.jpg?w=1920&ssl=1%201920w,%20https://i2.wp.com/www.vanguardngr.com/wp-content/uploads/2020/03/Catholic-Church.jpg?resize=300,200&ssl=1%20300w,%20https://i2.wp.com/www.vanguardngr.com/wp-content/uploads/2020/03/Catholic-Church.jpg?resize=1024,683&ssl=1%201024w,%20https://i2.wp.com/www.vanguardngr.com/wp-content/uploads/2020/03/Catholic-Church.jpg?resize=768,512&ssl=1%20768w,%20https://i2.wp.com/www.vanguardngr.com/wp-content/uploads/2020/03/Catholic-Church.jpg?resize=1536,1024&ssl=1%201536w,%20https://i2.wp.com/www.vanguardngr.com/wp-content/uploads/2020/03/Catholic-Church.jpg?resize=58,39&ssl=1%2058w,%20https://i2.wp.com/www.vanguardngr.com/wp-content/uploads/2020/03/Catholic-Church.jpg?resize=260,173&ssl=1%20260w,%20https://i2.wp.com/www.vanguardngr.com/wp-content/uploads/2020/03/Catholic-Church.jpg?resize=195,130&ssl=1%20195w,%20https://i2.wp.com/www.vanguardngr.com/wp-content/uploads/2020/03/Catholic-Church.jpg?resize=115,77&ssl=1%20115w,%20https://i2.wp.com/www.vanguardngr.com/wp-content/uploads/2020/03/Catholic-Church.jpg?w=1280&ssl=1%201280w"
                                img-alt="Image"
                                img-top
                                tag="article"
                                style="max-width: 20rem;"
                                class="mb-2"
                        >
                            <b-card-text v-html="announcement.body">{{announcement.body}}</b-card-text>

                            <b-button href="#" variant="primary">Read more</b-button>
                        </b-card>
                    </div>

                    <!--<div class="announcement-box">
                        <template v-if="announcement.image !== ''">
                            <img :src="announcement.image" alt="" class="img-fluid">
                        </template>
                        <template v-else>
                            <img src="https://picsum.photos/id/341/400/200" alt="" class="img-fluid">
                        </template>
                        <div class="program-date text-center">
                            <i class="icon ion-md-megaphone"></i>
                        </div>
                        <h3 class="announcement-header">{{announcement.title}}</h3>
                        <p class="description" v-html="announcement.body">
                            {{announcement.body}}
                        </p>
                    </div>-->
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {firestoreDB} from "../config/firebase";

    const announcementRef = firestoreDB.collection("announcements").where("parishID", "==", "2").orderBy("dateCreated", "desc");

    export default {
        name: "Announcement",
        data(){
            return {
                announcementList:[]
            }
        },
        methods: {
            populateAnnouncement(){
                announcementRef.get().then((docSnapshots) => {
                    if(!docSnapshots.empty){
                        docSnapshots.forEach((doc) => {
                            this.announcementList.push(doc.data());
                        })
                    }
                })
            }
        },
        created() {
            window.scrollTo(0, 0);
            this.populateAnnouncement();
        }
    }
</script>

<style scoped>
    .announcement{
        background-color: #fff;
    }
    .announcement-container{
        margin-bottom: 20px;
    }
    .announcement-box{
        background: #fff;
        position: relative;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
        z-index: 2;
        transition: all 0.3s ease 0s;
    }
    .announcement-box:hover{
        box-shadow: 0px 60px 60px rgba(0,0,0,0.1);
        position: relative;
        z-index: 100;
        transform: translate(0, -10px)
    }
    .announcement-box img{
        width: 100%;
    }
    .announcement-box .program-date{
        position: absolute;
        width: 100px;
        height: 100px;
        background: #E12993;
        top:0;
        left:0;
        padding:10px
    }
    .announcement-box .program-date i, .announcement-box .program-date h3{
        color:#fff;
        font-size: 48px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 0;
    }
    .announcement-box .announcement-header{
        text-align: center;
        text-transform: capitalize;
        margin-top:10px
    }
    .announcement-box .program-date p{
        font-size: 15px;
        color:#fff;
        text-align: center;
    }
    .announcement-box .description{
        padding:10px
    }
</style>